module.exports = __webpack_public_path__ + "static/media/discount-audio-visual.3f60abdd.png";